/* custom-title.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._1EqgXlgZxp%7Bmax-width%3A200px%7D%0A._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D%0A._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D%0A._03SyCP2ADO%7Bpadding-inline-end%3Avar(--ds-space-100%2C8px)%7D%0A._3iDTPbYbGa%7Bdisplay%3Anone%7D%0A%40media%20(min-width%3A64rem)%7B._2rc81eQ4SZ._2rc81eQ4SZ%7Bdisplay%3Aflex%7D%7D%0A._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");










import { forwardRef, type ReactNode } from 'react';
import { useHasCustomTheme } from './themed/has-custom-theme-context';
const styles = {
  root: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _1ANEUSLRg7 _1EqgXlgZxp _39HuIbz8Lp _0LQT5E1Y8M _03SyCP2ADO _3iDTPbYbGa _2rc81eQ4SZ",
  subtleText: "_1UtDYzZpcK"
};
type CustomTitleProps = {
  /**
   * The custom title value to display.
   */
  children: ReactNode;
  /**
   * A unique string that appears as data attribute `data-testid` in the rendered code, serving as a hook for automated tests.
   */
  testId?: string;
};

/**
 * __Custom title__
 *
 * A custom site title to be displayed in the top navigation, to the right of the logo.
 * It is hidden on smaller viewports.
 */
export const CustomTitle: React.ForwardRefExoticComponent<React.PropsWithoutRef<CustomTitleProps> & React.RefAttributes<HTMLDivElement>> = forwardRef(function CustomTitle({
  children,
  testId
}: CustomTitleProps, ref: React.ForwardedRef<HTMLDivElement>) {
  const hasCustomTheme = useHasCustomTheme();
  return <div ref={ref} data-testid={testId} className={ax([styles.root, !hasCustomTheme && styles.subtleText])}>
			{children}
		</div>;
});